export function getSerializedTasksData(tasks, jobId) {
  let tasksData = tasks.map(task => ({ task_id: task.quote_task_id ? task.quote_task_id : 0, task_label: task.task_label }))
  return {
    job_id: jobId,
    selected_tasks: JSON.stringify(tasksData)
  }
}
